/**
 * Returns an inline style object with fontSize set in points,
 * based on per-section override or global resume setting.
 * Returns {} when no custom size is configured (template defaults apply).
 */
export const getFontStyle = (resume, sectionKey) => {
  const sectionSize = resume?.font_size_sections?.[sectionKey];
  const globalSize = resume?.font_size_global;
  const size = sectionSize || globalSize;
  return size ? { fontSize: `${size}pt` } : {};
};

/**
 * Returns a font style for section headers, proportionally larger
 * than the body text (body size + 4pt, or template default).
 */
export const getHeaderFontStyle = (resume, sectionKey) => {
  const sectionSize = resume?.font_size_sections?.[sectionKey];
  const globalSize = resume?.font_size_global;
  const size = sectionSize || globalSize;
  return size ? { fontSize: `${Math.min(size + 4, 24)}pt` } : {};
};

export const FONT_SIZE_SECTION_KEYS = [
  { key: 'header', label: 'Header (Name, Headline, Contact)' },
  { key: 'summary', label: 'Professional Summary' },
  { key: 'core_skills', label: 'Core Skills' },
  { key: 'experience', label: 'Work Experience' },
  { key: 'education', label: 'Education' },
  { key: 'training', label: 'Training & Professional Development' },
  { key: 'skills', label: 'Skills' },
  { key: 'certifications', label: 'License or Certification' },
  { key: 'languages', label: 'Languages' },
];
